module.exports = __webpack_public_path__ + "img/tcnlogo.194ef4f0.png";